/*
  File: Login.css
  Author: Binish Mookken
  Date: April-June 2024

  Description:

*/

import React, { useState } from "react";
import {
  Input,
  Button,
  Avatar,
  Tooltip,
  Collapse,
  Tag,
  CollapseProps,
} from "antd";
import { KeyOutlined, LockFilled } from "@ant-design/icons";
import Header from "./Header";
import { useAuth } from "./context/AuthContext";
import { Role, User } from "./types";
import myProfileIcon from "./icons/my-profile.gif";
import "./MyProfile.css";
import parsePhoneNumberFromString from "libphonenumber-js";
import ChagnePasswordModal from "./ChangePasswordModal";

const { Panel } = Collapse;

const MyProfileComponent: React.FC<{ user: User }> = ({ user }) => {
  const [searchValue, setSearchValue] = useState<string>("");
  const [resetModalVisible, setResetModalVisible] = useState(false); // State to control the visibility of the modal
  const [activeKey, setActiveKey] = useState<string | string[]>([]);

  // Handle the change of the collapse panel
  const onChange: CollapseProps["onChange"] = (key) => {
    setActiveKey(key);
  };

  const formatPhoneNumber = (phoneNumber: string) => {
    const phoneNumberObj = parsePhoneNumberFromString(phoneNumber, "US");
    if (phoneNumberObj) {
      return phoneNumberObj.formatNational();
    }
    return phoneNumber;
  };
  return (
    <div>
      <div className="header-container">
        <div className="agent-info">
          <div className="agent-name">
            {user.firstName} {user.lastName}
          </div>
          <div>
            <Tag
              color={user.status === "active" ? "green" : "red"}
              style={{
                lineHeight: "2",
                fontWeight: "700",
                borderRadius: "0",
                fontFamily: "ubuntu",
              }}
            >
              {user.status.toUpperCase()}
            </Tag>
          </div>
        </div>

        <div className="agent-details" style={{ margin: "10px 0px" }}>
          <div className="agent-details-column">
            <div className="agent-label">Name</div>
            <span>{user?.full_name}</span>
          </div>
          <div className="agent-details-column">
            <div className="agent-label">Email</div>
            <span>{user?.email}</span>
          </div>
          <div className="agent-details-column">
            <div className="agent-label">Phone Number</div>
            <span>{user ? formatPhoneNumber(user.phone_number) : ""}</span>
          </div>
          <div className="agent-details-column">
            <div className="agent-label">Created On</div>
            <span>{new Date(user.created_ts).toLocaleDateString()} </span>
          </div>
        </div>
        <div style={{ padding: "20px 0px" }}>
          <Button
            type="primary"
            icon={<KeyOutlined />}
            onClick={() => setResetModalVisible(true)} // Open the modal on button click
          >
            Change Password
          </Button>
        </div>
        <ChagnePasswordModal
          visible={resetModalVisible}
          onClose={() => setResetModalVisible(false)} // Close the modal
        />
      </div>
      {/* <div
        className="roles-container"
        style={{ padding: "0px 0px", background: "black" }}
      >
        <div className="roles-header" style={{ padding: "2px 20px" }}>
          My Roles & Permissions
        </div>
        <div className="role-search-bar">
          <Input
            placeholder="Search roles..."
            allowClear
            size="large"
            onChange={(e) => setSearchValue(e.target.value)}
            value={searchValue}
            style={{
              width: "100%",
              padding: "7px", // Adding padding for better appearance
              fontSize: "15px", // Increasing font size
            }}
          />
        </div>
        <Collapse
          accordion
          activeKey={activeKey}
          onChange={onChange}
          style={{
            borderRadius: "0px",
            border: "1px solid black",
            padding: "0px",
          }}
        >
          {user.roles.map((role) => (
            <Panel
              header={role.name}
              key={role.id}
              style={{
                padding: "0px",
                background: "black",
              }}
            >
              <div
                className="permissions-container"
                style={{ maxHeight: "400px", overflow: "auto" }}
              >
                {role.role_permissions
                  .filter((permission) =>
                    permission.description
                      .toLowerCase()
                      .includes(searchValue.toLowerCase())
                  )
                  .sort((a, b) => {
                    if (a.description < b.description) return -1;
                    if (a.description > b.description) return 1;
                    return 0;
                  })
                  .map((permission) => (
                    <ul
                      key={permission.id}
                      className="permission-items"
                      style={{
                        margin: "0px",
                      }}
                    >
                      <li>
                        <span style={{ fontSize: "16px" }}>
                          {permission.description}{" "}
                        </span>
                        <div>
                          <small style={{ color: "#d89614" }}>
                            {permission.notes}
                          </small>
                        </div>
                      </li>
                    </ul>
                  ))}
              </div>
            </Panel>
          ))}
        </Collapse>
      </div> */}
    </div>
  );
};

const MyProfilePage: React.FC = () => {
  const { user } = useAuth();
  return (
    <div className="dashboard">
      <div className="dashboard-container">
        <Header
          header="My Profile"
          subheader="View your info or change your password."
          icon={myProfileIcon}
        />
        {user && <MyProfileComponent user={user} />}
      </div>
    </div>
  );
};

export default MyProfilePage;
